/**
 * CARIBE7 MODULES
 */

import Emitter from '@shared/services/main/events';
import RequestClient from '@shared/services/main/request-client';

import {default as RequestCancellable} from '@shared/services/base/traits/RequestCancellable';
import {default as EventsListCallable} from '@shared/services/base/traits/events/ListCallable';
import {default as EventsCreateCallable} from '@shared/services/base/traits/events/CreateCallable';
import {default as EventsReadCallable} from '@shared/services/base/traits/events/ReadCallable';
import {default as EventsUpdateCallable} from '@shared/services/base/traits/events/UpdateCallable';
import {default as EventsDeleteCallable} from '@shared/services/base/traits/events/DeleteCallable';

/**
 * This class describes a base service. Encapsulate business logics
 *
 * @class      BaseService (name)
 */
function BaseService(component) {
  /**
   * Construct set value
   */
  this.component = component;
}

/**
 * Extends
 */
BaseService.prototype = Object.assign(BaseService.prototype, RequestCancellable.prototype);
BaseService.prototype = Object.assign(BaseService.prototype, EventsListCallable.prototype);
BaseService.prototype = Object.assign(BaseService.prototype, EventsCreateCallable.prototype);
BaseService.prototype = Object.assign(BaseService.prototype, EventsReadCallable.prototype);
BaseService.prototype = Object.assign(BaseService.prototype, EventsUpdateCallable.prototype);
BaseService.prototype = Object.assign(BaseService.prototype, EventsDeleteCallable.prototype);

/**
 * ADD BELOW FOR EXTRA METHODS HERE AFTER EXTENDS AS IT MAY BE REPLACE BY
 * EXTENDS
 */


/**
 * Gets the component.
 *
 * @return     {Object||null}  The component.
 */
BaseService.prototype.getComponent = function() {
    return this.component;
  }

/**
 * Sets the component.
 *
 * @param      {Object||null}  component  The component
 * @return     {Object}
 */
BaseService.prototype.setComponent = function(component) {
  this.component = component;
  return this;
}

/**
 * Sample for parent method call
 */
BaseService.prototype.parentCall = function() {
  console.log("Base::parentCall");
}

/**
 * Sample for inherited method call
 */
BaseService.prototype.inheritedCall = function() {
    console.log("Base::inheritedCall");
  }

/**
 * Removes events.
 *
 * @param      {Array}  event_names  The event names
 */
BaseService.prototype.removeEvents = function(event_names) {
  if (typeof event_names != "object") {
    return this;
  }

  for (const name of event_names) {
    Emitter.off(name);
  }
  return this;
}

/**
 * Register events
 *
 * @param      {Object}  events_map  The events map
 * @param      {Object}  service     The service
 * @return     {Object}  { description_of_the_return_value }
 */
BaseService.prototype.registerEvents = function(events_map, service) {
  const keys = Object.entries(events_map);
  for (const [name, callback_name] of keys) {
    try {
    Emitter.register(name, service[callback_name].bind(service));
    }
    catch(err) {
      console.error(
        '%cBaseService::registerEvents',
        'background-color:#f49805;color:#fff;font-weight:bolder;',
        ' ➤ Failed to bind event!'
        + ' ➤ Name :: ['
        + name
        + '] ➤ Callback :: ['
        + callback_name
        + '] ➤ Service :: ',
        service
      );
    }

  }
  return this;
}


/**
 * Bind respective event cycle
 *
 * @param      {Object}  request_instance    The request instance
 * @param      {string}  success_event_name  The success event name
 * @param      {string}  fail_event_name     The fail event name
 * @return     {Object}  { description_of_the_return_value }
 */
BaseService.prototype.bindResultEvents = function(request_instance, success_event_name, fail_event_name) {
  request_instance.then((response) => {
      Emitter.emit(success_event_name, response);
  });
  request_instance.catch((error) => {
      Emitter.emit(fail_event_name, error);
  });
  request_instance.finally(() => {
    this.getComponent().setState({loader: false});
    /**
     * Always remove interceptor after use
     */
    if (this.used_interceptor) {
      RequestClient.interceptors.request.eject(this.used_interceptor);
    }
  });
  return this;
}

/**
 * Redirect method from a componentn with router
 *
 * @param      {<type>}   [path=null]  The path
 * @return     {boolean}  { description_of_the_return_value }
 */
BaseService.prototype.redirect = function(path = null) {
    if (!path) {
        return true;
    }
    this.getComponent().redirect(path);
}


BaseService.prototype.addInterceptor = function() {
  this.used_interceptor = RequestClient.interceptors.request.use(
    async config => {
      config.service_class = this;
      return config;
    },
    error => Promise.reject(error)
  );
}


export default BaseService;
